import React, { useContext, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "../styles/navbar.css";

import { UserContext } from "../context/UserContext";

export default function AppNavbar() {
  const { user, setUser } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let currUser = localStorage.getItem("user");
    if (currUser && location.pathname == "/") {
      navigate("/home");
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("token");
    if (query) {
      localStorage.setItem("user", JSON.stringify(query));
      setUser(query);
      navigate("/home");
      toast.success("Logged in successfully");
    }
  }, []);

  const signOut = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <Navbar className="navbar" bg="light" variant="light" sticky="top">
      <Toaster position="top-right" />
      <Container>
        <Nav className="me-auto">
          <Link to="/" className="navbar-brand">
            SYNERGY
          </Link>
        </Nav>

        <Nav>
          {!user && (
            <Link className="nav-link" to="/signup">
              Sign Up
            </Link>
          )}
          {!user && (
            <Link className="nav-link" to="/">
              Login
            </Link>
          )}

          {user && (
            <Link className="nav-link" to="/home">
              Home
            </Link>
          )}
          
            <Link className="nav-link" to="/forum">
              Forum
            </Link>
          {user && (
            <Link className="nav-link" to="/explore">
              Explore
            </Link>
          )}
          {user && (
            <Link className="nav-link" to="/profile">
              Profile
            </Link>
          )}
          <Link className="nav-link" to="/contact">
              Contact
            </Link>
          {user && <Nav.Link onClick={signOut}>Sign Out</Nav.Link>}
        </Nav>
      </Container>
    </Navbar>
  );
}
